import i18n from "../i18n";

export const getLoadDrop = (loadDrop) => {
  if (loadDrop > 0) {
    return i18n.t("common:loadDrop.jump", { percent: loadDrop });
  } else if (loadDrop < 0) {
    return i18n.t("common:loadDrop.drop", { percent: Math.abs(loadDrop) });
  }
  return i18n.t("common:loadDrop.empty");
};
